import { Dispatch } from 'redux'
const { createLogic } = require('redux-logic')
import { toast } from 'react-toastify'

import { Point } from 'src/lib/interfaces/point'

import { RootState } from '../rootReducer'

import history from '../../history'

import { File } from 'src/lib/interfaces/File.interface'
import { Claim } from 'src/lib/interfaces/Claim.interface'
import { Accident } from 'src/lib/interfaces/Accident.interface'
import { ClaimArea } from 'src/lib/interfaces/ClaimArea.interface'
import { AccidentType } from 'src/lib/interfaces/AccidentType.interface'
import { CountSummary } from 'src/lib/interfaces/CountSummary.interface'
import { AccidentStatus } from 'src/lib/interfaces/AccidentStatus.interface'
import { AccidentComment } from 'src/lib/interfaces/AccidentComment.interface'

import {
  actionTypes,
  fetchClaimError,
  removeClaimError,
  upsertClaimError,
  fetchClaimSuccess,
  searchClaimsError,
  fetchAccidentError,
  fetchAccidentFiles,
  removeClaimSuccess,
  upsertClaimSuccess,
  removeAccidentError,
  searchClaimsSuccess,
  upsertAccidentError,
  AccidentUpsertAction,
  fetchAccidentSuccess,
  fetchClaimAreasError,
  fetchOpenClaimsError,
  removeAccidentSuccess,
  upsertAccidentSuccess,
  fetchClaimAreasSuccess,
  fetchOpenClaimsSuccess,
  fetchAccidentFilesError,
  setCurrentAccidentError,
  uploadAccidentFileError,
  postAccidentCommentError,
  AccidentFetchFilesAction,
  AccidentsFetchListAction,
  AccidentTypesFetchAction,
  AccidentUploadFileAction,
  AccidentsFetchClaimAction,
  AccidentPostCommentAction,
  AccidentsSetCurrentAction,
  AccidentStatusFetchAction,
  AccidentUpsertClaimAction,
  fetchAccidentFilesSuccess,
  setCurrentAccidentSuccess,
  uploadAccidentFileSuccess,
  AccidentsRemoveClaimAction,
  postAccidentCommentSuccess,
  AccidentFilterChangedAction,
  AccidentsSearchClaimsAction,
  AccidentsFetchAccidentAction,
  AccidentsRemoveAccidentAction,
  AccidentsFetchClaimAreasAction,
  AccidentsFetchOpenClaimsAction,
  setAccidentManagerApprovalError,
  AccidentSetManagerApprovalAction,
  fetchAccidentsListDispatchCommand,
  setAccidentManagerApprovalSuccess,
  fetchAccidentTypesErrorDispatchCommand,
  fetchAccidentsListErrorDispatchCommand,
  fetchAccidentStatusErrorDispatchCommand,
  accidentPendingStatusCountFetchSucceeded,
  fetchAccidentsListSuccessDispatchCommand,
  fetchAccidentTypesSuccessDispatchCommand,
  fetchAccidentStatusSuccessDispatchCommand,
  accidentSummaryFetchSucceededDispatchCommand,
  accidentHistogramFetchSucceededDispatchCommand
} from './actions'

import { toggleSidebarActionDispatchCommand } from '../app/actions'

import {
  getClaim,
  getAccident,
  removeClaim,
  upsertClaim,
  getAccidents,
  searchClaims,
  getClaimAreas,
  getOpenClaims,
  removeAccident,
  upsertAccident,
  getAccidentFiles,
  getAccidentTypes,
  getAccidentStatus,
  uploadAccidentFile,
  postAccidentComment,
  getAccidentsSummary,
  FetchAccidentsQuery,
  // getAccidentHistogram,
  setAccidentManagerApproval,
  getAccidentsPendingStatusCount
} from 'src/lib/api/accidents'

const moment = require('moment')
const get = require('lodash/get')

type OnDoneType = () => void

const onUpsertAccidentLogic = createLogic({
  type: actionTypes.ACCIDENT_UPSERT,
  process({ action }: { action: AccidentUpsertAction }, dispatch: Dispatch, done: OnDoneType) {
    upsertAccident(action.payload.accident)
      .then((accident: Accident) => {
        dispatch(upsertAccidentSuccess(accident))

        toast.success('Accident successfully saved')
        history.push(`/accidents/${accident.id}`)
      })
      .catch(err => {
        const errorMessage = get(err, 'response.data.error', 'Error saving the accident. Please try again')
        toast.error(errorMessage)
        dispatch(upsertAccidentError(errorMessage))
      })
      .then(done)
  }
})

const onUpsertClaimLogic = createLogic({
  type: actionTypes.ACCIDENT_UPSERT_CLAIM,
  process({ action }: { action: AccidentUpsertClaimAction }, dispatch: Dispatch, done: OnDoneType) {
    upsertClaim(action.payload.claim)
      .then((claim: Claim) => {
        dispatch(upsertClaimSuccess(claim))

        toast.success('Claim successfully saved')
        history.push(`/accidents/${action.payload.claim.accidentId}`)
      })
      .catch(err => {
        const errorMessage = get(err, 'response.data.error', 'Error creating the claim. Please try again')
        toast.error(errorMessage)
        dispatch(upsertClaimError(errorMessage))
      })
      .then(done)
  }
})

const onFetchAccidentsLogic = createLogic({
  type: actionTypes.ACCIDENTS_FETCH_LIST,
  cancelType: actionTypes.ACCIDENT_FILTER_PARAMS_UPDATED,
  process({ getState, action }: { getState: () => RootState, action: AccidentsFetchListAction }, dispatch: Dispatch, done: OnDoneType) {
    const filterParams = getState().accidents.filterParams
    const {
      sortBy,
      location,
      sortOrder,
      lossDateTo,
      lossDateFrom,
      accidentTypes,
      accidentStatus,
      managerApproval,
      locationPosition
    } = filterParams

    const queryParams: FetchAccidentsQuery = {}
    if (location) {
      queryParams.location = location
    }

    if (accidentStatus) {
      queryParams.status = accidentStatus
    }

    if (accidentTypes) {
      queryParams.type = accidentTypes
    }

    if (lossDateFrom && moment(lossDateFrom).isValid()) {
      queryParams.fromDate = lossDateFrom
    }

    if (lossDateTo && moment(lossDateTo).isValid()) {
      queryParams.toDate = lossDateTo
    }

    if (sortBy) {
      queryParams.sort = sortBy
    }

    if (sortOrder) {
      queryParams.order = sortOrder
    }

    if (locationPosition) {
      queryParams.position = locationPosition
    }

    if (managerApproval) {
      queryParams.approval = managerApproval
    }

    dispatch(toggleSidebarActionDispatchCommand(false));
    // Accidents list
    getAccidents(queryParams)
      .then((accidents: Accident[]) => dispatch(fetchAccidentsListSuccessDispatchCommand(accidents)))
    // Accidents histogram
      // .then(() => getAccidentHistogram(queryParams))
      // .then((data: Point[]) => dispatch(accidentHistogramFetchSucceededDispatchCommand(data)))
    // Accidents summary
      .then(() => getAccidentsSummary(queryParams))
      .then((data: any) => dispatch(accidentSummaryFetchSucceededDispatchCommand(data)))
    // Accidents `pending` status count
      .then(getAccidentsPendingStatusCount)
      .then((data: CountSummary) => dispatch(accidentPendingStatusCountFetchSucceeded(data)))
    // Error Handling
      .catch((err) => dispatch(fetchAccidentsListErrorDispatchCommand(err)))
      .then(() => done())
  }
})

const onRemoveAccidentLogic = createLogic({
  type: actionTypes.ACCIDENT_REMOVE,
  process({ action }: { action: AccidentsRemoveAccidentAction }, dispatch: Dispatch, done: OnDoneType) {
    removeAccident(action.payload.accidentId)
    .then(() => {
      toast.success('Accident successfully removed')

      if (action.payload.next) {
        action.payload.next(true)
      }

      dispatch(removeAccidentSuccess())
    })
    .catch(err => {
      toast.error('Error removing accident. Please try again.')

      if (action.payload.next) {
        action.payload.next(false)
      }

      dispatch(removeAccidentError(err))
    })
    .then(done)
  }
})

const onSetCurrentAccidentLogic = createLogic({
  type: actionTypes.ACCIDENTS_SET_CURRENT,
  process({ action }: { action: AccidentsSetCurrentAction }, dispatch: Dispatch, done: OnDoneType) {
    const { accident } = action.payload

    if (!accident) {
      return done()
    }

    getAccident(accident.id)
      .then((fetchedAccident: Accident) => {
        dispatch(setCurrentAccidentSuccess(fetchedAccident))
        dispatch(fetchAccidentFiles(accident.id))
      })
      .catch((err) => dispatch(setCurrentAccidentError(err)))
      .then(done)
  }
})

const onSetAccidentManagerApprovalLogic = createLogic({
  type: actionTypes.ACCIDENT_SET_MANAGER_APPROVAL,
  process({ action }: { action: AccidentSetManagerApprovalAction }, dispatch: Dispatch, done: OnDoneType) {
    setAccidentManagerApproval(action.payload.accidentId, action.payload.managerApproval)
      .then((accident: Accident) => {
        toast.success('Manager approval successfully set')
        dispatch(setAccidentManagerApprovalSuccess(accident))
      })
      .catch(err => {
        toast.error('Error setting manager approval')
        dispatch(setAccidentManagerApprovalError(err))
      })
      .then(() => {
        if (action.payload.next) {
          action.payload.next()
        }

        done()
      })
  }
})

const onPostAccidentCommentLogic = createLogic({
  type: actionTypes.ACCIDENT_POST_COMMENT,
  process({ action }: { action: AccidentPostCommentAction }, dispatch: Dispatch, done: OnDoneType) {
    postAccidentComment(action.payload.accidentId, action.payload.comment)
      .then((comment: AccidentComment) => dispatch(postAccidentCommentSuccess(action.payload.accidentId, comment)))
      .catch(err => {
        const errorMessage = get(err, 'response.data.error', 'Error posting the comment. Please try again')
        toast.error(errorMessage)
        dispatch(postAccidentCommentError(errorMessage))
      })
      .then(done)
  }
})

const onFetchAccidentFilesLogic = createLogic({
  type: actionTypes.ACCIDENT_FETCH_FILES,
  process({ action }: { action: AccidentFetchFilesAction }, dispatch: Dispatch, done: OnDoneType) {
    getAccidentFiles(action.payload.accidentId)
      .then((files: File[]) => dispatch(fetchAccidentFilesSuccess(files, action.payload.accidentId)))
      .catch(err => dispatch(fetchAccidentFilesError(err)))
      .then(done)
  }
})

const onUploadAccidentFileLogic = createLogic({
  type: actionTypes.ACCIDENT_UPLOAD_FILE,
  process({ action }: { action: AccidentUploadFileAction }, dispatch: Dispatch, done: OnDoneType) {
    uploadAccidentFile(action.payload.accidentId, action.payload.file)
      .then(() => {
        dispatch(uploadAccidentFileSuccess())

        const accidentId = parseInt(`${action.payload.accidentId}`, 10)
        dispatch(fetchAccidentFiles(accidentId))
      })
      .catch(err => {
        const errorMessage = get(err, 'response.data.error', 'Error uploading the file. Please try again')
        dispatch(uploadAccidentFileError(errorMessage))
        toast.error(errorMessage)
      })
      .then(done)
  }
})

const onFetchAccidentStatusLogic = createLogic({
  type: actionTypes.ACCIDENT_STATUS_FETCH_LIST,
  process({ action }: { action: AccidentStatusFetchAction }, dispatch: Dispatch, done: OnDoneType) {
    getAccidentStatus()
      .then((accidentStatus: AccidentStatus[]) => dispatch(fetchAccidentStatusSuccessDispatchCommand(accidentStatus)))
      .catch((err) => dispatch(fetchAccidentStatusErrorDispatchCommand(err)))
      .then(() => done())
  }
})

const onFetchAccidentTypesLogic = createLogic({
  type: actionTypes.ACCIDENT_TYPES_FETCH_LIST,
  process({ action }: { action: AccidentTypesFetchAction }, dispatch: Dispatch, done: OnDoneType) {
    getAccidentTypes()
      .then((accidentTypes: AccidentType[]) => dispatch(fetchAccidentTypesSuccessDispatchCommand(accidentTypes)))
      .catch((err) => dispatch(fetchAccidentTypesErrorDispatchCommand(err)))
      .then(() => done())
  }
})

const onAccidentFilterParamsChanged = createLogic({
  type: actionTypes.ACCIDENT_FILTER_PARAMS_UPDATED,
  latest: true,
  process({ action }: { action: AccidentFilterChangedAction }, dispatch: Dispatch, done: OnDoneType) {
    dispatch(fetchAccidentsListDispatchCommand())
    if (action.payload.next) { action.payload.next() }
    done()
  }
})

const onFetchAccidentLogic = createLogic({
  type: actionTypes.ACCIDENTS_FETCH,
  latest: true,
  process({ action }: { action: AccidentsFetchAccidentAction }, dispatch: Dispatch, done: OnDoneType) {
    const { next, accidentId } = action.payload

    getAccident(accidentId)
      .then((accident: Accident) => {
        dispatch(fetchAccidentSuccess(accident))

        if (next) {
          next(null, accident)
        }
      })
      .catch(err => {
        dispatch(fetchAccidentError(err))

        if (next) {
          next(err)
        }
      })
      .then(done)
  }
})

const onFetchClaimLogic = createLogic({
  type: actionTypes.ACCIDENTS_FETCH_CLAIM,
  latest: true,
  process({ action }: { action: AccidentsFetchClaimAction }, dispatch: Dispatch, done: OnDoneType) {
    getClaim(action.payload.claimId)
      .then((claim: Claim) => dispatch(fetchClaimSuccess(claim)))
      .catch(err => dispatch(fetchClaimError(err)))
      .then(done)
  }
})

const onFetchOpenClaimsLogic = createLogic({
  type: actionTypes.ACCIDENT_FETCH_OPEN_CLAIMS,
  latest: true,
  process({ action }: { action: AccidentsFetchOpenClaimsAction }, dispatch: Dispatch, done: OnDoneType) {
    getOpenClaims()
      .then((claims: [Claim]) => dispatch(fetchOpenClaimsSuccess(claims)))
      .catch(err => dispatch(fetchOpenClaimsError(err)))
      .then(() => {
        if (action.payload.next) { action.payload.next() }
        done()
      })
  }
})

const onFetchClaimAreasLogic = createLogic({
  type: actionTypes.ACCIDENT_FETCH_CLAIM_AREAS_LIST,
  latest: true,
  process({ action }: { action: AccidentsFetchClaimAreasAction }, dispatch: Dispatch, done: OnDoneType) {
    getClaimAreas()
      .then((claimAreas: [ClaimArea]) => dispatch(fetchClaimAreasSuccess(claimAreas)))
      .catch(err => dispatch(fetchClaimAreasError(err)))
      .then(done)
  }
})

const onSearchClaimsLogic = createLogic({
  type: actionTypes.ACCIDENTS_SEARCH_CLAIMS,
  latest: true,
  process({ action }: { action: AccidentsSearchClaimsAction }, dispatch: Dispatch, done: OnDoneType) {
    searchClaims(action.payload.params)
      .then((claims: [Claim]) => dispatch(searchClaimsSuccess(claims)))
      .catch(err => {
        dispatch(searchClaimsError('There was an error.\nPlease try again.'))
      })
      .then(done)
  }
})

const onRemoveClaimLogic = createLogic({
  type: actionTypes.ACCIDENTS_REMOVE_CLAIM,
  process({ action }: { action: AccidentsRemoveClaimAction }, dispatch: Dispatch, done: OnDoneType) {
    removeClaim(action.payload.claimId)
      .then(() => {
        toast.success('Claim successfully removed')

        dispatch(removeClaimSuccess())
      })
      .catch(err => {
        toast.error('Error removing claim. Please try again.')
        dispatch(removeClaimError(err))
      })
      .then(() => {
        if (action.payload.next) {
          action.payload.next()
        }

        done()
      })
  }
})

export const accidentsLogic = [
  onUpsertAccidentLogic,
  onUpsertClaimLogic,
  onFetchAccidentsLogic,
  onFetchOpenClaimsLogic,
  onRemoveAccidentLogic,
  onSetCurrentAccidentLogic,
  onSetAccidentManagerApprovalLogic,
  onPostAccidentCommentLogic,
  onFetchAccidentFilesLogic,
  onUploadAccidentFileLogic,
  onFetchAccidentTypesLogic,
  onFetchAccidentStatusLogic,
  onAccidentFilterParamsChanged,
  onFetchAccidentLogic,
  onFetchClaimLogic,
  onFetchClaimAreasLogic,
  onSearchClaimsLogic,
  onRemoveClaimLogic
]



// WEBPACK FOOTER //
// ./src/store/accidents/logic.ts